// @ts-check
import React from 'react';
import cx from 'classnames';
import BaseModal from 'react-overlays/lib/Modal';
import Transition, { ENTERING, ENTERED } from 'react-transition-group/Transition';
import styles from './Modal.module.scss';

const FADE_DURATION = 200;

const fadeStyles = {
  [ENTERING]: styles.in,
  [ENTERED]: styles.in,
};

const Fade = ({ children, ...props }) => {
  return (
    <Transition {...props} timeout={FADE_DURATION}>
      {(status, innerProps) =>
        React.cloneElement(children, {
          ...innerProps,
          className: cx(styles.fade, fadeStyles[status], children.props.className),
        })
      }
    </Transition>
  );
};

const modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflowY: 'scroll',
};

const backdropStyle = {
  ...modalStyle,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5,
};

const Modal = ({ show, onHide, children, dialogClassName = '' }) => (
  <BaseModal
    aria-labelledby="modal-label"
    style={modalStyle}
    backdropStyle={backdropStyle}
    show={show}
    onHide={onHide}
    transition={Fade}
  >
    <div data-spec-id="modal-dialog" className={cx(dialogClassName, styles.PreferralModal__dialog)}>
      {children}
    </div>
  </BaseModal>
);

export default Modal;
